/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Log } from "../../logging/Log";
import type { TInputEvent, InputInterceptor } from "../types/TInputEvent";

/**
 * Logs all input events at debug level via the project logger.
 * Pass `enabled = false` to create a no-op interceptor.
 */
export function createLoggerInterceptor(isEnabled: boolean): InputInterceptor {
  const TAG: string = "LoggerInterceptor";

  return (event: TInputEvent): void => {
    if (!isEnabled) {
      return;
    }
    Log.d(
      TAG,
      `${event.action} (${event.eventType}) [${event.source}]${event.repeat ? " [repeat]" : ""}`
    );
  };
}
